import { render, staticRenderFns } from "./FullTxtArtAnalysisResult.vue?vue&type=template&id=59b36a96&scoped=true"
import script from "./FullTxtArtAnalysisResult.vue?vue&type=script&lang=js"
export * from "./FullTxtArtAnalysisResult.vue?vue&type=script&lang=js"
import style0 from "./FullTxtArtAnalysisResult.vue?vue&type=style&index=0&id=59b36a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b36a96",
  null
  
)

export default component.exports